import { Button, Grid, MenuItem, TextField } from "@mui/material";
import InputMask from "react-input-mask";
import styles from "./styles.module.css";
import { useEffect, useState } from "react";
import { validarFormatacaoDocumento } from "../../../services/validation.service";
import BtnImportarDados from "../BtnImportarDados";

const ResponsavelFinanceiro = ({
  handleStep,
  dataForm,
  setDataForm,
  setMsg,
  setOpenSnackbarErro,
  error,
  setError,
  handleError,
  handleHelperText,
}) => {
  const [mascaraDocumento, setMascaraDocumento] =
    useState("99.999.999/9999-99");
  const [valid, setValid] = useState({
    documento: true,
    cpf: false,
  });

  const tiposDocumento = ["CNPJ", "RG", "RNE"];

  const handleVerificarDocumento = async (value, type) => {
    const response = await validarFormatacaoDocumento(value, type);

    switch (type) {
      case "CNPJ":
        if (!response) {
          setValid({
            ...valid,
            documento: false,
          });
          setMsg("CNPJ inválido!");
          setOpenSnackbarErro(true);
        } else {
          setValid({
            ...valid,
            documento: true,
          });
        }
        break;
      case "CPF":
        if (!response) {
          setValid({
            ...valid,
            cpf: false,
          });
          setMsg("CPF inválido!");
          setOpenSnackbarErro(true);
        } else {
          setValid({
            ...valid,
            cpf: true,
          });
        }
        break;

      default:
        break;
    }
  };

  useEffect(() => {
    setError(false);
  }, []);

  useEffect(() => {
    switch (dataForm?.responsavelFinanceiro?.tipoDocumento) {
      case "RG":
        {
          setMascaraDocumento("********************");
          setValid({
            ...valid,
            documento: true,
          });
        }
        break;
      case "CNPJ":
        {
          setMascaraDocumento("99.999.999/9999-99");
          setValid({
            ...valid,
            documento: true,
          });
        }
        break;
      case "RNE":
        {
          setMascaraDocumento("a9999999-a");
          setValid({
            ...valid,
            documento: true,
          });
        }
        break;

      default:
        break;
    }
  }, [dataForm?.responsavelFinanceiro?.tipoDocumento]);

  useEffect(() => {
    const cnpj = dataForm?.responsavelFinanceiro?.documento;
    const cpf = dataForm?.responsavelFinanceiro?.cpf;

    if (dataForm?.responsavelFinanceiro?.tipoDocumento === "CNPJ") {
      if (cnpj?.length === 14) {
        handleVerificarDocumento(cnpj, "CNPJ");
      } else {
        setValid({
          ...valid,
          documento: false,
        });
      }
    } else {
      setValid({
        ...valid,
        documento: true,
      });
    }
    if (cpf?.length === 11) {
      handleVerificarDocumento(cpf, "CPF");
    } else {
      setValid({
        ...valid,
        cpf: false,
      });
    }
  }, [
    dataForm?.responsavelFinanceiro?.documento,
    dataForm?.responsavelFinanceiro?.cpf,
  ]);

  const handleNext = (e) => {
    e.preventDefault();
    const form = e.target;

    if (dataForm?.responsavelFinanceiro?.cpf && !valid.cpf) {
      setMsg("CPF Inválido");
      setOpenSnackbarErro(true);
    }

    if (form.checkValidity() && valid.cpf) {
      handleStep(3);
    } else {
      setError(true);
    }
  };

  const handleBack = () => {
    handleStep(1);
  };

  const handleChange = (e) => {
    const { name } = e.target;
    let value = e.target.value;

    switch (name) {
      case "documento":
        value = value.replace(/[^\w\s]/gi, "");
        break;
      case "cpf":
        value = value.replace(/[^\w\s]/gi, "");
        break;
    }

    setDataForm({
      ...dataForm,
      responsavelFinanceiro: {
        ...dataForm.responsavelFinanceiro,
        [name]: value,
      },
    });
  };

  return (
    <form className={styles.form_container} onSubmit={handleNext} noValidate>
      <Grid container spacing={2} sx={{ marginBottom: "1rem" }}>
        <Grid item xs={12} sm={4} lg={2}>
          <BtnImportarDados
            step={3}
            dataForm={dataForm}
            setDataForm={setDataForm}
          />
        </Grid>
        <Grid item xs={12} sm={4} lg={5}>
          <TextField
            size="small"
            label="Nome"
            name="nome"
            fullWidth
            value={dataForm?.responsavelFinanceiro?.nome || ""}
            onChange={handleChange}
            error={handleError("responsavelFinanceiro", "nome")}
            helperText={handleHelperText("responsavelFinanceiro", "nome")}
            required
          />
        </Grid>
        <Grid item xs={12} sm={4} lg={5}>
          <TextField
            size="small"
            label="E-mail"
            name="email"
            fullWidth
            value={dataForm?.responsavelFinanceiro?.email || ""}
            error={handleError("responsavelFinanceiro", "email")}
            helperText={handleHelperText("responsavelFinanceiro", "email")}
            onChange={handleChange}
            required
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <TextField
            size="small"
            label="Tipo Documento"
            name="tipoDocumento"
            fullWidth
            value={dataForm?.responsavelFinanceiro?.tipoDocumento || "CNPJ"}
            onChange={handleChange}
            select
          >
            {tiposDocumento.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} sm={3} md={3}>
          <InputMask
            mask={mascaraDocumento}
            maskChar={null}
            onChange={handleChange}
            value={dataForm?.responsavelFinanceiro?.documento || ""}
          >
            {() => (
              <TextField
                size="small"
                label="Documento"
                name="documento"
                fullWidth
                error={
                  dataForm?.responsavelFinanceiro?.tipoDocumento === "CNPJ" &&
                  !valid.documento
                    ? true
                    : handleError("responsavelFinanceiro", "documento")
                }
                helperText={handleHelperText(
                  "responsavelFinanceiro",
                  "documento"
                )}
                color={
                  dataForm?.responsavelFinanceiro?.tipoDocumento === "CNPJ" &&
                  !valid.documento
                    ? "error"
                    : ""
                }
                required
              />
            )}
          </InputMask>
        </Grid>
        <Grid item xs={12} sm={3}>
          <InputMask
            mask="999.999.999-99"
            maskChar={null}
            value={dataForm?.responsavelFinanceiro?.cpf || ""}
            onChange={handleChange}
          >
            {() => (
              <TextField
                size="small"
                label="CPF"
                fullWidth
                name="cpf"
                error={
                  error && (!valid.cpf || !dataForm?.responsavelFinanceiro?.cpf)
                }
                helperText={handleHelperText("responsavelFinanceiro", "cpf")}
                color={
                  valid.cpf && dataForm?.responsavelFinanceiro?.cpf
                    ? "success"
                    : ""
                }
                required
              />
            )}
          </InputMask>
        </Grid>
        <Grid item xs={12} sm={2}>
          <InputMask
            mask="(99) 9999 9999"
            maskChar={null}
            value={dataForm?.responsavelFinanceiro?.telefone || ""}
            onChange={handleChange}
          >
            {() => (
              <TextField
                size="small"
                name="telefone"
                label="Telefone"
                fullWidth
              />
            )}
          </InputMask>
        </Grid>

        <Grid item xs={12} sm={2}>
          <InputMask
            mask="(99) 9 9999 9999"
            maskChar={null}
            value={dataForm?.responsavelFinanceiro?.whatsapp || ""}
            onChange={handleChange}
          >
            {() => (
              <TextField
                size="small"
                label="WhatsApp"
                name="whatsapp"
                fullWidth
                error={handleError("responsavelFinanceiro", "whatsapp")}
                helperText={handleHelperText(
                  "responsavelFinanceiro",
                  "whatsapp"
                )}
                required
              />
            )}
          </InputMask>
        </Grid>
      </Grid>
      <div className={styles.container_button}>
        <Button className={styles.button_back} onClick={handleBack}>
          Voltar
        </Button>
        <Button className={styles.button_next} type="submit">
          Avançar
        </Button>
      </div>
    </form>
  );
};

export default ResponsavelFinanceiro;
